import { API_ENDPOINTS } from '@/services/config';

export const DISPLAY_IMAGE_UPDATED_EVENT = 'display-images-updated';
export const DISPLAY_IMAGE_EXTENSIONS = ['.png', '.jpg', '.jpeg'];

export function normalizeEntityType(entityType) {
  return String(entityType || '').trim().toLowerCase();
}

export function normalizeEntityId(entityId) {
  const numericValue = Number(entityId);
  return Number.isFinite(numericValue) ? numericValue : entityId;
}

export function matchesDisplayImageEntity(detail, entityType, entityId) {
  if (!detail) return false;
  return normalizeEntityType(detail.entityType) === normalizeEntityType(entityType)
    && normalizeEntityId(detail.entityId) === normalizeEntityId(entityId);
}

export function emitDisplayImagesUpdated(entityType, entityId) {
  if (typeof window === 'undefined') return;

  window.dispatchEvent(new CustomEvent(DISPLAY_IMAGE_UPDATED_EVENT, {
    detail: {
      entityType: normalizeEntityType(entityType),
      entityId: normalizeEntityId(entityId),
    },
  }));
}

export function getFileNameFromPath(path) {
  if (!path) return 'Unnamed file';
  return String(path).replace(/\\/g, '/').split('/').pop() || 'Unnamed file';
}

export function isDisplayImageEligible(file) {
  const filePath = String(file?.path || file?.name || '').toLowerCase();
  return DISPLAY_IMAGE_EXTENSIONS.some((extension) => filePath.endsWith(extension));
}

export function buildDisplayImageUrl(fileId, entraId) {
  if (!fileId || !entraId) return '';
  return `${API_ENDPOINTS.file(fileId)}?entra_id=${encodeURIComponent(entraId)}`;
}

export function getDisplayImageOrder(displayImage, fallbackIndex = 0) {
  const explicitOrder = displayImage?.display_image?.display_order ?? displayImage?.display_order ?? null;
  const numericOrder = Number(explicitOrder);
  if (Number.isFinite(numericOrder)) {
    return numericOrder;
  }
  return fallbackIndex + 1;
}
